import posthog from "posthog-js";

// // // //

/**
 * resetAnalyticsIdentity
 * Clears the Posthog identity (distinct ID, super properties, session) so that
 * subsequent events are attributed to a fresh anonymous person.
 *
 * MUST be called on logout — without it, the next visitor on a shared device
 * continues emitting events under the previous user's distinct ID, merging two
 * people into one profile and corrupting funnel + retention analysis.
 *
 * Doc: https://posthog.com/docs/product-analytics/identify#reset-after-logout
 */
export function resetAnalyticsIdentity() {
    // NOTE - `posthog.reset()` no-ops (with a console warning) when the SDK
    // hasn't been initialized, so this is safe to call unconditionally.
    posthog.reset();
}
